import { IClassname } from '@/lib/shared/model/classname';

export const FilterGolf = ({ className }: IClassname) => {
  return (
    <svg
      className={className}
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.625 19.625H6.5M8.375 19.625H6.5M6.5 7.625H7.15925C8.17787 7.62504 9.15475 8.02971 9.875 8.75C10.5958 9.47 11.5722 9.875 12.5907 9.875H14V4.625H13.3407C12.3222 4.625 11.345 4.22 10.625 3.5C9.90425 2.78 8.92775 2.375 7.90925 2.375H6.5V19.625M19.25 15.875C19.25 15.875 16.625 12.875 10.625 12.875C9.665 12.875 8.7905 12.9515 8 13.0812M2 15.875C2 15.875 2.94575 14.7943 5 13.9295M13.25 18.125C13.25 18.5228 13.408 18.9044 13.6893 19.1857C13.9706 19.467 14.3522 19.625 14.75 19.625C15.1478 19.625 15.5294 19.467 15.8107 19.1857C16.092 18.9044 16.25 18.5228 16.25 18.125C16.25 17.7272 16.092 17.3456 15.8107 17.0643C15.5294 16.783 15.1478 16.625 14.75 16.625C14.3522 16.625 13.9706 16.783 13.6893 17.0643C13.408 17.3456 13.25 17.7272 13.25 18.125Z"
        stroke="white"
        strokeWidth="1.6"
      />
    </svg>
  );
};
